module.exports = __webpack_public_path__ + "img/25.044075fb.jpg";